import type { VoidFunctionComponent } from 'react';

import References from '../../../../shared/vulns/Drawer/References';
import type { SelectedVuln } from '../../../../../../shared/organizationPackages/response';

import { getSelectedVulnReferences } from './utils';

type Props = { selectedVuln?: SelectedVuln };

/**
 * Container component for the VulnerabilityDrawerReferences
 */
const PackageVersionVulnerabilityDrawerReferences: VoidFunctionComponent<Props> = ({ selectedVuln }) => {
  //  References is an array of URLs.
  const references = getSelectedVulnReferences(selectedVuln);
  return (
    <References references={references} />
  );
};

export default PackageVersionVulnerabilityDrawerReferences;
